import { useTranslation } from "react-i18next";
import { AppCard } from "@/components/ui";
import { Clock, Shield, Coffee, DollarSign } from "lucide-react";

const DEFAULT_PILLAR = { icon: Clock, color: "text-rose" };

const PILLAR_CONFIG = [
  { icon: Clock, color: "text-rose" },
  { icon: Shield, color: "text-success" },
  { icon: Coffee, color: "text-accent" },
  { icon: DollarSign, color: "text-warning" },
];

/**
 * Outcomes section — 4 value pillar cards with benefit labels.
 * Rosé Pine Dawn luxury aesthetic with hover lift and large rounded corners.
 */
export function OutcomesSection() {
  const { t } = useTranslation();

  const pillars = t("landing.outcomes.pillars", {
    returnObjects: true,
  }) as {
    benefit: string;
    title: string;
    description: string;
  }[];

  return (
    <section
      id="strategic-outcomes"
      className="py-32 px-6 bg-surface/50 scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-24 space-y-4">
          <h2 className="text-sm font-bold text-rose uppercase tracking-[0.4em]">
            {t("landing.outcomes.subtitle")}
          </h2>
          <h3 className="text-5xl font-bold">
            {t("landing.outcomes.heading")}
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((pillar, i) => {
            const config = PILLAR_CONFIG[i] ?? DEFAULT_PILLAR;
            const Icon = config.icon;
            return (
              <AppCard
                key={i}
                className="group bg-surface p-10 rounded-[2.5rem] border border-border hover:border-success/20 transition-all shadow-sm hover:shadow-xl hover:-translate-y-2"
              >
                <div className="w-14 h-14 rounded-2xl bg-background flex items-center justify-center mb-10 group-hover:scale-110 transition-transform shadow-sm">
                  <Icon className={`w-7 h-7 ${config.color}`} />
                </div>
                <h4 className="text-xs font-black text-success uppercase tracking-[0.2em] mb-3">
                  {pillar.benefit}
                </h4>
                <h5 className="text-2xl font-bold text-foreground mb-4">
                  {pillar.title}
                </h5>
                <p className="text-foreground-secondary text-sm leading-relaxed font-light">
                  {pillar.description}
                </p>
              </AppCard>
            );
          })}
        </div>
      </div>
    </section>
  );
}
